/**!
 * Created by Leonardo Cheslacki on 03/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './HelpersController';

import {
    PageCurrent,
    PageMain
} from './../page';

import {
    SupportEffect,
    SupportKeyboard,
    SupportMask,
    SupportSelect,
    SupportTouch,
    SupportTouchCanvas
} from './../support';

import {
    Stage360,
    StageGallery,
    StageLocalization,
    StageMarquee,
    StageMemory,
    StagePaginate,
    StagePin,
    StageQuiz,
    StageScroll,
    StageSlider,
    StageSun,
    StageVideo,
    StageView,
    StageWheel,
    StageZoom
} from './../stage';

import {
    FormRadio
} from './../form';

import {
    LayerCamera,
    LayerDifferential,
    LayerPin
} from './../Layer';

import config from './../../../../config';

import WithType from './WithType';

let _this = {};

/**
 *
 */
class HelpersAllTap extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.$default_page = this._void;
        this.$default_page_sub = this._void;
        this.$current_name = null;
        this.$current_name_sub = null;
        this.$current_frame = null;
        this.$current_frame_sub = null;
        this.$speed_marker_slider = this.$controller.big_0;

        this.$supportEffect = SupportEffect(this);

        this.$supportKeyboard = SupportKeyboard(this);

        this.$supportMask = SupportMask(this);

        this.$supportSelect = SupportSelect(this);

        this.$supportTouch = SupportTouch(this);

        this.$supportTouchCanvas = SupportTouchCanvas(this);

        this.$pageMain = PageMain(this);

        this.$pageCurrent = PageCurrent(this);

        this.$stage360 = Stage360(this);

        this.$stageGallery = StageGallery(this);

        this.$stageLocalization = StageLocalization(this);

        this.$stageMarquee = StageMarquee(this);

        this.$stageMemory = StageMemory(this);

        this.$stagePaginate = StagePaginate(this);

        this.$stagePin = StagePin(this);

        this.$stageQuiz = StageQuiz(this);

        this.$stageScroll = StageScroll(this);

        this.$stageSlider = StageSlider(this);

        this.$stageSun = StageSun(this);

        this.$stageVideo = StageVideo(this);

        this.$stageView = StageView(this);

        this.$stageWheel = StageWheel(this);

        this.$stageZoom = StageZoom(this);

        this.$layerDifferential = LayerDifferential(this);

        this.$layerCamera = LayerCamera(this);

        this.$layerPin = LayerPin(this);

        this.$formRadio = FormRadio(this);

        _this = this;
    };
}

/**
 *
 * @type {{}}
 */
HelpersAllTap.propTypes = {
    routes: PropTypes.object
};

/**
 *
 * @type {{}}
 */
HelpersAllTap.defaultProps = config.default;

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersAllTap, {className: 'HelpersAllTap'});
